export const Info = [
  {
    id: 0,
    fullName: 'Vishal Verma',
  },

  {
    id: 1,
    phone: '7814716299',
  },
  {
    id: 2,
    email: 'gajanandverma003@syncglob.com',
  },
  {
    id: 3,
    status: 'active',
  },
  {
    id: 4,
    address: '177, ganaga vihar colony',
  },
];

export const relation = [
  { id: 1, name: 'Father' },
  { id: 2, name: 'Mother' },
  { id: 3, name: 'Sister' },
  { id: 4, name: 'Husband' },
  { id: 5, name: 'Wife' },
  { id: 6, name: 'Child' },
  { id: 7, name: 'Brother' },
];
